<template>
    <div class="page-aboutUs">
        <!--悬浮头部-->
        <Header></Header>
        <!--banner-->
        <div class="banner">
            <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/story/story_banner.jpg">
            <ul class="content">
                <li class="active">
                    <div class="title">
                        <p id="world">半个世纪的故事</p>
                    </div>
                </li>
                <li>
                    <div class="title">
                        <router-link to="/about/china">
                            <p>爱在中国</p>
                        </router-link>
                    </div>
                </li>
                <li>
                    <div class="title">
                        <router-link to="/about/belief">
                            <p>KRK信念</p>
                        </router-link>
                    </div>
                </li>
            </ul>
        </div>
        <div class="story-section">
            <div class="header w1200 clearfix">
                <div class="header-left">
                    <div class="hr"></div>
                    <h2>半个世纪的故事</h2>
                    <h3>Since 1961</h3>
                </div>
                <div class="header-right">Brand Story</div>
            </div>
            <p class="p1 w1200">从1961年开始至今，美国知名连锁幼儿园品牌Kids 'R' Kids已经走过了半个多世纪。
                <br>60多年来，Kids 'R' Kids在美国建立了180多座幼儿园，足迹遍布全美16个州。
                <br>2014年5月，Kids 'R' Kids登陆中国，把与美国幼儿园同步的专业课程带到了中国。
            </p>
            <div class="p-div w1200">
                <div class="left">
                    <h2>Kids 'R' Kids， Since 1961</h2>
                    <p>Kids 'R' Kids品牌源起于1961年。在美国乔治亚州亚特兰大，年仅14岁的Pat Vinson遭遇了一场巨大的家庭变故——父亲去世，一家人陷入困境。为了维持生计，Pat在自己家中的地下室和妈妈一起帮人照看孩子赚钱，而这个小小的地下室，就是以后闻名全美的Kids 'R' Kids的前身——“Kiddie City”。</p>
                </div>
                <div class="right bg1">
                    <div class="bg"></div>
                    <img
                        src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/story/story_img1.jpg"
                    >
                </div>
            </div>
            <div class="p-div2">
                <div class="w1200">
                    <div class="p-div2-bg" v-show="this.$store.state.isMobile"></div>
                    <div class="left bg2">
                        <div class="bg"></div>
                        <img
                            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/story/story_img2.jpg"
                        >
                    </div>
                    <div class="right bg1">
                        <h2>Kids 'R' Kids，孩子就是孩子</h2>
                        <p>随着每天和孩子们的深入接触，Pat意识到，托儿所带给孩子们的，不仅是一个安全的环境，更应该是有意义的教育，帮助孩子从小在知识、身心和教养上打好基础，长大后更好地融入社会。于是，1985年Kids 'R' Kids的品牌正式诞生，品牌名称来自于Pat小女儿Darlene的建议——”Kids 'R' Kids”意即“孩子就是孩子”，尊重孩子的自然生长规律，给予孩子更有利于其成长的学习和生活方式。</p>
                    </div>
                </div>
            </div>
            <div class="p-div w1200 div3">
                <div class="left">
                    <h2>Hug First Then Teach</h2>
                    <p>Pat Vinson先生认为，拥抱可以让孩子感受到安全与快乐，而后他们才能更好地打开学习知识与探索世界的开关，因此将“Hug First, Then Teach（先拥抱，再启迪）”作为教育理念注入了Kids 'R' Kids的灵魂中。
                        <br>
                        <br>在整整半个多世纪的时间里，Kids 'R' Kids作为世界知名的幼儿教育品牌，其真诚独特的教育理念越来越深入人心。这不仅仅是因为它打破了传统育儿和日托教育的界限，更在于它表达了“一切以孩子为中心”的价值观，先给予呵护和关爱，再去传播知识，教书育人。
                    </p>
                </div>
                <div class="right">
                    <img src="../../assets/image/story_HugTeach.png">
                </div>
            </div>
            <div class="map">
                <div class="w1200">
                    <img class="us" src="../../assets/image/story_us.png">
                    <img class="cn" src="../../assets/image/story_china.png">
                </div>
            </div>
            <div class="p-div w1200 div4">
                <div class="left">
                    <div class="bg"></div>
                    <img
                        src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/story/story_img3.jpg"
                    >
                </div>
                <div class="right">
                    <h2>Kids 'R' Kids 爱的大家庭</h2>
                    <p>如今，Kids 'R' Kids来到中国，将秉持着“为中国家庭提供更透明、更安全、更科技的全球化幼儿成长体验”的使命，让更多中国孩子从小体验和美国同步的幼儿园课程，拥有“分享、自信、家国情怀和国际视野”的价值观，成为真正的世界小公民。</p>
                </div>
            </div>
            <div class="video-div">
                <div class="w1200">
                    <div class="video">
                        <img v-show="posterShow" :src="videoBg" @click.stop="videoPlayer(src)">
                        <video-player
                            v-show="videoShow"
                            class="video-player-box"
                            ref="videoPlayer"
                            :options="playerOptions"
                            :playsinline="true"
                            customEventName="customstatechangedeventname"
                            @play="onPlayerPlay($event)"
                            @pause="onPlayerPause($event)"
                            @ended="onPlayerEnded($event)"
                            @waiting="onPlayerWaiting($event)"
                            @playing="onPlayerPlaying($event)"
                            @loadeddata="onPlayerLoadeddata($event)"
                            @timeupdate="onPlayerTimeupdate($event)"
                            @canplay="onPlayerCanplay($event)"
                            @canplaythrough="onPlayerCanplaythrough($event)"
                            @statechanged="playerStateChanged($event)"
                            @ready="playerReadied"
                        ></video-player>
                    </div>
                </div>
            </div>
        </div>
        <!--底部-->
        <v-footer></v-footer>
    </div>
</template>

<script>
import videoBg from '@/assets/image/story_video.png'
import Header from '@/components/header/Header' // 悬浮头部
import Footer from '@/components/footer/footer' // 底部模块
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

export default {
  data () {
    return {
      videoBg:
        'https://krk-website.oss-cn-beijing.aliyuncs.com/img/story/story_video.jpg',
      videoShow: false,
      posterShow: true,
      src: 'https://krk-website.oss-cn-beijing.aliyuncs.com/img/video/life.mp4',
      playerOptions: {
        // videojs options
        height: '480',
        aspectRatio: '16:9',
        fluid: true,
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'video/mp4',
            src:
              'https://krk-website.oss-cn-beijing.aliyuncs.com/img/video/life.mp4' // 视频地址
          }
        ],
        poster: videoBg
      }
    }
  },
  components: {
    Header,
    'v-footer': Footer,
    videoPlayer
  },
  mounted () {
    this.exitFullScreen(this.exitScreen) // 退出全屏
  },
  computed: {
    player: {
      get: function () {
        return this.$refs.videoPlayer.player
      },
      set: function (val, old) {}
    }
  },
  methods: {
    exitScreen () {
      // 退出全屏事件
      //   this.posterShow = true;
      //   this.videoShow = false;
      //   this.player.pause();
    },
    videoPlayer (src) {
      this.player.src(src)
      this.posterShow = false
      this.videoShow = true
      // this.player.requestFullscreen();
      this.player.play()
    },
    onPlayerPlay (player) {
      // console.log('player play!', player)
    },
    onPlayerPause (player) {
      // console.log('player pause!', player)
    },
    playerStateChanged (playerCurrentState) {},
    playerReadied (player) {
      //  this.player.isFullscreen(true);
    },
    onPlayerLoadeddata (player) {},
    onPlayerTimeupdate (player) {},
    onPlayerPlaying (player) {},
    onPlayerCanplay (player) {},
    onPlayerCanplaythrough (player) {},
    onPlayerEnded (player) {},
    onPlayerWaiting (player) {}
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.page-aboutUs {
  .banner {
    width: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .content {
      position: absolute;
      left: 50%;
      margin-left: -600px;
      bottom: 0;
      height: 68px;
      li {
        position: relative;
        float: left;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        cursor: pointer;
        div.title {
          #world {
            width: 236px;
            height: 68px;
          }
          p {
            width: 163px;
            height: 68px;
            font-size: 24px;
            color: rgba(255, 255, 255, 1);
            line-height: 68px;
          }
        }
      }
      .active {
        background: rgba(0, 40, 93, 1);
      }
      li:hover {
        background: rgba(0, 40, 93, 1);
      }
    }
  }
  .story-section {
    width: 100%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    .w1200 {
      width: 1200px !important;
      margin: 0 auto;
    }
    .header {
      width: 1200px;
      height: 167px;
      overflow: hidden;
      margin-top: 133px;
      .header-left {
        float: left;
        .hr {
          width: 96px;
          height: 4px;
          background: rgba(174, 149, 79, 1);
        }
        h2 {
          width: 375px;
          height: 96px;
          font-size: 48px;
          font-weight: 500;
          color: #333333;
          line-height: 96px;
        }
        h3 {
          width: 142px;
          height: 29px;
          line-height: 29px;
          background: rgba(174, 149, 79, 1);
          font-size: 24px;
          font-family: TimesNewRoman;
          font-weight: bold;
          font-style: italic;
          color: rgba(255, 255, 255, 1);
          text-align: center;
        }
      }
      .header-right {
        float: left;
        width: 390px;
        margin-top: 16px;
        margin-left: 430px;
        height: 73px;
        font-size: 73px;
        font-family: TimesNewRoman;
        font-style: italic;
        color: rgba(204, 204, 204, 1);
        line-height: 73px;
        text-align: left;
      }
    }
    .p1 {
      margin-top: 104px;
      margin-bottom: 87px;
      font-size: 16px;
      color: #333333;
      line-height: 32px;
    }
    .p-div {
      clear: both;
      height: 353px;
      padding-bottom: 137px;
      overflow: hidden;
      .left {
        float: left;
        width: 547px;
        h2 {
          height: 116px;
          line-height: 116px;
          font-size: 24px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
        p {
          width: 547px;
          height: 146px;
          font-size: 16px;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
        }
      }
      .right {
        float: left;
        margin-left: 95px;
        .bg {
          width: 529px;
          height: 353px;
          position: relative;
          left: 26px;
          top: 24px;
          background-color: #ae954f;
        }
        img {
          position: relative;
          top: -353px;
          left: 0px;
          width: 529px;
          height: 353px;
        }
      }
    }
    .p-div2 {
      clear: both;
      height: 351px;
      padding: 122px 0px 90px 0px;
      background: url("https://krk-website.oss-cn-beijing.aliyuncs.com/img/story/story_bg1.jpg")
        no-repeat;
      overflow: hidden;
      .left {
        float: left;
        width: 525px;
        .bg {
          position: relative;
          width: 525px;
          height: 351px;
          left: 0px;
          top: 23px;
          background-color: #0e4082;
        }
        img {
          position: relative;
          top: -352px;
          left: 23px;
          width: 525px;
          height: 352px;
        }
      }
      .right {
        float: left;
        margin-left: 104px;
        h2 {
          height: 128px;
          line-height: 128px;
          font-size: 24px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
        p {
          width: 548px;
          height: 177px;
          font-size: 16px;
          color: #333333;
          line-height: 32px;
        }
      }
    }
    .p-div.div3 {
      padding-top: 125px;
      padding-bottom: 126px;
      height: auto;
      .left {
        h2 {
          height: 25px;
          font-size: 24px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          line-height: 36px;
          margin-bottom: 43px;
        }
        p {
          width: 550px;
          height: 241px;
        }
      }
      .right {
        img {
          position: static;
          width: 546px;
          height: 238px;
          margin-top: 37px;
        }
      }
    }
    .p-div.div4 {
      clear: both;
      padding: 136px 0px 137px 0px;
      .left {
        .bg {
          background-color: #ae954f;
          position: relative;
          width: 525px;
          height: 351px;
          left: 0px;
          top: 23px;
        }
        img {
          position: relative;
          top: -352px;
          left: 23px;
          width: 525px;
          height: 352px;
        }
      }
      .right {
        h2 {
          margin-top: 96px;
          margin-bottom: 47px;
          height: 23px;
          font-size: 24px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
        p {
          width: 548px;
          font-size: 16px;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
        }
      }
    }
    .map {
      height: 560px;
      background: url("https://krk-website.oss-cn-beijing.aliyuncs.com/img/story/story_bg2.jpg")
        no-repeat;
      background-size: auto 560px;
      div {
        padding-top: 130px;
        .us {
          display: inline-block;
          width: 542px;
          height: 339px;
        }
        .cn {
          display: inline-block;
          margin-left: 150px;
          width: 462px;
          height: 361px;
        }
      }
    }
    .video-div {
      width: 100%;
      height: 868px;
      box-sizing: border-box;
      background: url("https://krk-website.oss-cn-beijing.aliyuncs.com/img/story/story_bg3.jpg")
        no-repeat;
      background-size: auto 868px;
      padding-top: 205px;
      div {
        position: relative;
        .video {
          position: absolute;
          width: 860px;
          height: 480px;
          right: 0px;
          img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99;
          }
          .video-js .vjs-progress-holder .vjs-play-progress {
            // top:-3.5px;
          }
          .video-js .vjs-progress-control:hover .vjs-play-progress {
            // top:-11.5px;
          }
          .video-js .vjs-mouse-display {
            position: absolute;
            top: 0;
          }
          .video-js .vjs-play-progress {
            position: absolute;
            top: 0;
          }
          .video-js .vjs-menu {
            position: absolute;
          }
          .vjs-fullscreen .vjs-control-bar {
            position: fixed;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .page-aboutUs {
    .banner {
      width: 100%;
      position: relative;
      padding-top: 45px;
      img {
        display: block;
        width: 100%;
      }
      .content {
        width: 100%;
        position: absolute;
        left: 0;
        margin-left: 0;
        bottom: 0;
        height: 35px;
        display: flex;
        white-space: nowrap;
        overflow-x: scroll;
        overflow-y: hidden;
        -webkit-backface-visibility: hidden;
        -webkit-perspective: 1000;
        -webkit-overflow-scrolling: touch;
        text-align: justify;
        li {
          width: 100%;
          div.title {
            #world {
              width: auto;
              padding: 0 24px;
              height: 35px;
            }
            p {
              width: auto;
              padding: 0 24px;
              height: 35px;
              font-size: 14px;
              line-height: 35px;
            }
          }
        }
      }
    }
    .story-section {
      width: 100%;
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      .w1200 {
        width: 100% !important;
        margin: 0 auto;
      }
      .header {
        width: 100%;
        height: 64px;
        overflow: hidden;
        margin-top: 35px;
        .header-left {
          float: left;
          width: 100%;
          box-sizing: border-box;
          padding-left: 7%;
          .hr {
            width: 56px;
            height: 3px;
            background: rgba(174, 149, 79, 1);
          }
          h2 {
            width: 100%;
            height: 41px;
            font-size: 21px;
            font-weight: 500;
            color: #333333;
            line-height: 25px;
            font-family: PingFangSC-Medium;
            padding: 10px 0 8px;
            box-sizing: border-box;
          }
          h3 {
            width: 64px;
            height: 20px;
            font-size: 10px;
            font-family: TimesNewRomanPS-BoldItalicMT;
            font-weight: normal;
            line-height: 20px;
            background: rgba(174, 149, 79, 1);
            font-style: italic;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            padding: 0 5px;
          }
        }
        .header-right {
          display: none;
        }
      }
      .p1 {
        width: 100%;
        box-sizing: border-box;
        padding: 32px 8.5% 59px 6.8%;
        font-size: 12px;
        color: #333333;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        line-height: 21px;
      }
      .p-div {
        clear: both;
        position: relative;
        padding-bottom: 0;
        overflow: hidden;
        height: 450px;
        .left {
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          padding-bottom: 30px;
          h2 {
            width: 100%;
            box-sizing: border-box;
            padding-left: 7%;
            height: 30px;
            line-height: 18px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            font-size: 18px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            padding-bottom: 12px;
          }
          p {
            width: 100%;
            box-sizing: border-box;
            padding-left: 6.8%;
            padding-right: 8.9%;
            height: 130px;
            font-size: 13px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 21px;
          }
        }
        .right {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          box-sizing: border-box;
          clear: both;
          margin: 0;
          padding: 0 7.6% 0 8.1%;
          .bg {
            width: 95%;
            height: 200px;
            position: relative;
            left: 14px;
            top: 14px;
            background-color: #ae954f;
          }
          img {
            position: relative;
            top: -200px;
            left: 0px;
            width: 95%;
            height: auto;
          }
        }
      }
      .p-div2 {
        clear: both;
        background: none;
        padding: 0;
        position: relative;
        height: auto;
        .p-div2-bg {
            width: 100%;
            height: 200px;
            background: url("https://krk-website.oss-cn-beijing.aliyuncs.com/img/story/story_bg1.jpg")
            no-repeat;
            background-size: cover;
            overflow: hidden;
            position: absolute;
            left: 0;
            top: 0;

        }
        .left {
          width: 100%;
          padding: 37px 7.7% 0 8.1%;
          box-sizing: border-box;
          .bg {
            position: relative;
            width: 95%;
            height: 200px;
            left: 0px;
            top: 13px;
            background-color: #0e4082;
          }
          img {
            position: relative;
            top: -200px;
            left: 13px;
            width: 95%;
            height: auto;
          }
        }
        .right {
          width: 100%;
          box-sizing: border-box;
          margin: 0;
          margin-top: -154px;
          h2 {
            width: 100%;
            box-sizing: border-box;
            padding-left: 7%;
            height: 30px;
            line-height: 18px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            font-size: 18px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            padding-bottom: 12px;
          }
          p {
            width: 100%;
            box-sizing: border-box;
            padding-left: 6.8%;
            padding-right: 8.9%;
            height: 172px;
            font-size: 13px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 21px;
          }
        }
      }
      .p-div.div3 {
        clear: both;
        padding: 0;
        height: 509px;
        display: flex;
        flex-direction: column-reverse;
        .left {
            width: 100%;
            position: static;
            padding-bottom: 0;
          h2 {
            width: 100%;
            box-sizing: border-box;
            padding-left: 8.6%;
            height: 25px;
            line-height: 25px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            font-size: 21px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            margin: 0;
            margin-bottom: 22px;
            padding-bottom: 0;
          }
          p {
            width: 100%;
            box-sizing: border-box;
            padding-left: 8.2%;
            padding-right: 8.5%;
            height: 240px;
            font-size: 13px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 21px;
          }
        }
        .right {
            width: 100%;
            padding: 45px 10.4% 0 13%;
            box-sizing: border-box;
            margin-bottom: 25px;
          img {
            position: static;
            width: 100%;
            height: auto;
            margin: 0;
          }
        }
      }
      .p-div.div4 {
        clear: both;
        padding: 0;
        position: relative;
        display: flex;
        flex-direction: column;
        height: 403px;
        .left {
          width: 100%;
          padding: 0 7.7% 0 8.1%;
          box-sizing: border-box;
          .bg {
            position: relative;
            width: 95%;
            height: 200px;
            left: 0px;
            top: 13px;
            background-color: #ae954f;
          }
          img {
            position: relative;
            top: -200px;
            left: 13px;
            width: 95%;
            height: auto;
          }
        }
        .right {
          width: 100%;
          box-sizing: border-box;
          margin: 0;
          margin-top: 246px;
          h2 {
            width: 100%;
            box-sizing: border-box;
            padding-left: 0;
            height: 30px;
            line-height: 18px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            font-size: 18px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            padding-bottom: 12px;
            margin: 0;
          }
          p {
            width: 100%;
            box-sizing: border-box;
            padding-left: 0;
            padding-right: 0;
            height: 115px;
            font-size: 13px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 21px;
          }
        }
      }
      .map {
          width: 100%;
        height: 540px;
        background: none;
        div {
          padding-top: 58px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .us {
            width: 67.5%;
            height: auto;
            margin-bottom: 54px;
          }
          .cn {
            width: 64.3%;
            height: auto;
            margin: 0;
            margin-bottom: 76px;
          }
        }
      }
      .video-div {
        width: 100%;
        height: 245px;
        box-sizing: border-box;
        background: url("https://krk-website.oss-cn-beijing.aliyuncs.com/img/story/story_bg3.jpg")
          no-repeat;
        background-size: 146% 245px;
        background-position: -93px 0;
        padding-top: 0;
        padding: 33px 7.7% 37.5px;
        .w1200 {
          position: relative;
          padding: 0;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          .video {
            position: absolute;
            width: 100%;
            height: 100%;
            right: 0px;
            top: 0;
            img {
              width: 100%;
              height: auto;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 99;
            }
            .video-js .vjs-mouse-display {
              position: absolute;
              top: 0;
            }
            .video-js .vjs-play-progress {
              position: absolute;
              top: 0;
            }
            .video-js .vjs-menu {
              position: absolute;
            }
            .vjs-fullscreen .vjs-control-bar {
              position: fixed;
            }
          }
        }
      }
    }
  }
}
@media (min-width: 415px) and (max-width: 767px) {
  .page-aboutUs {
    .story-section {
      .p-div {
        .right {
          .bg {
            height: 411px;
            left: 14px;
            top: 14px;
          }
          img {
            top: -417px;
            left: -4px;
          }
        }
      }
      .p-div2 {
        .left {
          .bg {
            position: relative;
            height: 411px;
            left: 14px;
            top: 14px;
          }
          img {
            top: -411px;
            left: 27px;
          }
        }
      }
      .p-div.div4 {
        .left {
          .bg {
            position: relative;
            height: 411px;
            left: 14px;
            top: 14px;
          }
          img {
            top: -411px;
            left: 27px;
          }
        }
      }
    }
  }
}
@media (min-width: 376px) and (max-width: 414px) {
  .page-aboutUs {
    .story-section {
      .p-div {
        height: 465px;
        .left {
          padding-bottom: 22px;
        }
        .right {
          .bg {
            height: 222px;
            left: 14px;
            top: 14px;
          }
          img {
            top: -222px;
            left: 0;
          }
        }
      }
      .p-div2 {
        .left {
          .bg {
            position: relative;
            height: 222px;
            left: 0;
            top: 14px;
            background-color: #0e4082;
          }
          img {
            top: -221px;
            left: 13px;
          }
        }
        .right{
          p {
            height: 150px;
          }
        }
      }
      .map {
          height: 560px;
      }
      .p-div.div3 {
        height: 460px;
        .left{
          p {
            height: 215px;
          }
        }
      }
      .p-div.div4 {
        height: 430px;
        .right {
            margin-top: 260px;
        }
        .left {
          top: 0;
          .bg {
            position: relative;
            height: 220px;
            left: 0;
            top: 14px;
          }
          img {
            top: -220px;
            left: 13px;
          }
        }
      }
      .video-div {
        height: 262px;
        background-size: 146% 262px;
        background-position: -101px 0;
        padding: 33px 7.7% 37.5px;
      }
    }
  }
}
@media (min-width: 321px) and (max-width: 360px) {
  .page-aboutUs {
    .story-section {
      .p-div {
        .right {
          .bg {
            height: 192px;
            left: 14px;
            top: 14px;
          }
          img {
            top: -192px;
            left: 0;
          }
        }
      }
      .p-div2 {
        .left {
          .bg {
            height: 192px;
            left: 0px;
            top: 14px;
          }
          img {
            top: -192px;
            left: 14px;
          }
        }
      }
      .p-div.div3 {
        height: 470px;
        .left{
          p {
            height: 253px;
          }
        }
      }
      .map {
          height: 500px;
      }
      .p-div.div4 {
        .right {
            margin-top: 245px;
        }
        .left {
          .bg {
            position: relative;
            height: 192px;
            left: 0;
            top: 14px;
          }
          img {
            top: -192px;
            left: 13px;
          }
        }
      }
      .video-div {
        height: 235px;
        background-size: 144% 235px;
        background-position: -87px 0;
      }
    }
  }
}
@media (min-width: 320px) and (max-width: 320px) {
  .page-aboutUs {
    .story-section {
      .p-div {
        .right {
          .bg {
            height: 171px;
            left: 14px;
            top: 14px;
          }
          img {
            top: -171px;
            left: 0;
          }
        }
      }
      .p-div2 {
        .left {
          .bg {
            height: 171px;
            left: 0;
            top: 13px;
          }
          img {
            top: -171px;
            left: 13px;
          }
        }
        .right{
          margin-top: -136px;
          p {
            height: 192px;
          }
        }
      }
      .p-div.div3 {
        height: 470px;
        .left{
          p {
            height: 257px;
          }
        }
      }
      .map {
          height: 440px;
      }
      .p-div.div4 {
          height: 400px;
        .right {
            margin-top: 230px;
        }
        .left {
           top: 10px;
          .bg {
            position: relative;
            height: 171px;
            left: 0;
            top: 13px;
          }
          img {
            top: -171px;
            left: 13px;
          }
        }
      }
      .video-div {
        height: 218px;
        background-size: 142% 218px;
        background-position: -76px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about/story.vue